
export default function StorySection() {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            現場ストーリー｜「謎の荒れ面」が消えた日
          </h2>
        </div>
        
        <div className="bg-white rounded-2xl shadow-2xl p-12 relative overflow-hidden">
          {/* 背景装飾 */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-yellow-100 rounded-full opacity-20 -translate-y-16 translate-x-16"></div>
          <div className="absolute bottom-0 left-0 w-24 h-24 bg-blue-100 rounded-full opacity-20 translate-y-12 -translate-x-12"></div>
          
          <div className="relative z-10">
            <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed">
              <div className="mb-8">
                <div className="flex items-start mb-6">
                  <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-alarm-warning-line text-red-600 text-xl"></i>
                  </div>
                  <p className="text-lg mb-0">
                    <strong className="text-red-600">納期前夜、フェイスミルの面が突然荒れた。</strong><br />
                    刃を替えても、切削音のイヤなざわつきが消えない。班長の眉間は深く、誰もが追加の仕上げパスを覚悟した。
                  </p>
                </div>
              </div>

              <div className="mb-8">
                <div className="flex items-start mb-6">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-search-line text-blue-600 text-xl"></i>
                  </div>
                  <p className="text-lg mb-0">
                    <strong className="text-blue-600">そこで、venturionへ。</strong><br />
                    測定結果は振れ8μm。原因が"勘"から数値に変わった瞬間、場の空気が動く。<br />
                    2μm以下で振れを管理、突出し標準化。画面の緑ランプが灯り、再スタート。
                  </p>
                </div>
              </div>

              <div className="mb-8">
                <div className="flex items-start mb-6">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-music-line text-green-600 text-xl"></i>
                  </div>
                  <p className="text-lg mb-0">
                    <strong className="text-green-600">刃が噛んだ瞬間、音が澄んだ。</strong><br />
                    工具が滑るように走り、モニタに並ぶ値は落ち着いている。<br />
                    あの荒れ面は跡形もなく、仕上げパスは1回削減。面粗さは元の基準へ回復した。
                  </p>
                </div>
              </div>

              <div className="text-center">
                <div className="inline-flex items-center bg-yellow-50 border-2 border-yellow-200 rounded-xl px-8 py-4">
                  <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-trophy-line text-yellow-600 text-xl"></i>
                  </div>
                  <p className="text-xl font-bold text-gray-800 mb-0">
                    翌日も、その次も、寸法は日替わりの気まぐれをやめた。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 効果を強調するボックス */}
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          <div className="bg-white rounded-xl p-6 shadow-lg text-center">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-error-warning-line text-red-600 text-2xl"></i>
            </div>
            <h3 className="font-bold text-gray-900 mb-2">問題発生</h3>
            <p className="text-gray-600 text-sm">振れ8μm<br />荒れ面・追加パス</p>
          </div>
          
          <div className="bg-white rounded-xl p-6 shadow-lg text-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-settings-3-line text-blue-600 text-2xl"></i>
            </div>
            <h3 className="font-bold text-gray-900 mb-2">venturion</h3>
            <p className="text-gray-600 text-sm">2μmで管理<br />突出し標準化</p>
          </div>
          
          <div className="bg-white rounded-xl p-6 shadow-lg text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-check-line text-green-600 text-2xl"></i>
            </div>
            <h3 className="font-bold text-gray-900 mb-2">解決</h3>
            <p className="text-gray-600 text-sm">仕上げパス削減<br />安定した寸法</p>
          </div>
        </div>
      </div>
    </section>
  );
}
